<template>
  <view class="packet-open" wx:style="{{bgStyle}}">
    <view class="coupon" wx:for="{{couponListGroupNewMap}}" wx:key="product_id">
      <image wx:if="{{item.disabaled}}" class="cover" src="https://ut-static.udache.com/webx/ut/oVyOC7VVBrr2O73q4x0Ly.png"></image>
      <image wx:if="{{item.disabaled}}" class="failed" src="https://ut-static.udache.com/webx/ut/ZOyagwxob9FpGM74uSAJC.png"></image>
      <view class="tag" wx:style="{{item.tabImageStyle}}">{{item.product_line_tag_text}} <text wx:if="{{item.len > 1}}">包</text></view>
      <image class="icon" bindtap="couponClick(item)" src="https://ut-static.udache.com/webx/ut/Mn2FsSbutcB_CdldzPygy.png"></image>
      <view class="award" bindtap="couponClick(item)">
        <view class="mark">立享</view>
        <view class="amount">{{item.cap_amount}}</view>
        <view class="unit">{{item.unit}}</view>
      </view>"
      <view class="desc" bindtap="goToLink(item)">{{item.product_line_text}}</view>
    </view>
    <image class="coupon-cover" src="https://ut-static.udache.com/webx/ut/gXEUp_0RsGEpem7kPa2gM.png"></image>
    <button class="btn" bindtap="click">{{ btnText }}</button>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { pageStyle } from '../../lib/store'
import { utils } from '@didi/webx-js'
import { getStyle } from '../../lib/editor/utils.js'
// const product_line_map = {
//   159: '加油',
//   120: '代驾',
//   842: '洗车',
// }
const productLineTextMap = {
  159: '去加油 >',
  120: '叫代驾 >',
  842: '去洗车 >',
}
const productLineTag = {
  159: 'https://ut-static.udache.com/webx/ut/Q-25ZedTOeFmOXfzwmaAZ.png',
  120: 'https://ut-static.udache.com/webx/ut/5FyP7wXNMEQDZWcyA3i2m.png',
  842: 'https://ut-static.udache.com/webx/ut/wwgrsskZRJmNloCTqnQIW.png',
}
const productLineTagText = {
  159: '加油券',
  120: '代驾券',
  842: '洗车券',
}
createComponent({
  properties: {
    couponInfo: Array, // 领券前数据
    couponList: Array,
    btnText: String,
    template: String,
    config: {
      type: Object,
      value: () =>({}),
    },
  },
  data() {
    return {
      oilCoupons: [],
      driverCoupons: [],
      carCoupons: [],
    }
  },
  computed: {
    bgStyle() {
      return { backgroundImage: `url(${utils.webpUrl(pageStyle[this.template].couponListBg)})` }
    },
    couponListGroupNewMap() {
      const listMap = new Map()
      this.couponList.forEach(item => {
        const objValue = {}
        if (!listMap.has(item.product_id)) {
          objValue.product_id = item.product_id
          objValue.len = 1
          objValue.cap_amount = this.capAmountFixed(item.coupon.max_benefit_capacity.cap_amount)
          objValue.unit = '元'
          objValue.link = item.link
          objValue.tabImageStyle = getStyle({ 'backgroundImage':  productLineTag[item.product_id] })
          objValue.product_line_tag_text = productLineTagText[item.product_id]
          objValue.product_line_text = productLineTextMap[item.product_id]
          objValue.list = [ item ]
          listMap.set(item.product_id, objValue)
        } else {
          listMap.get(item.product_id).len += 1
          listMap.get(item.product_id).cap_amount += this.capAmountFixed(item.coupon.max_benefit_capacity.cap_amount)
          listMap.get(item.product_id).list.push(item)
        }
      })
      const get_product_ids = []
      const receiveCouponData = []
      for (const [ key, value ] of listMap) {
        get_product_ids.push(key)
        receiveCouponData.push(value)
      }
      console.log('get_product_ids====', get_product_ids)
      console.log('receiveCouponData====', receiveCouponData)
      const couponErr = [] // 未领到的券包
      this.couponInfo.forEach(item => {
        const couponObj = {
          len: 0,
        }
        if(!get_product_ids.includes(item.product_id)) {
          couponObj.product_id = item.product_id
          couponObj.len = couponObj.len + 1
          couponObj.max_benefit_capacity = item.coupon.max_benefit_capacity
          couponObj.cap_amount = item.coupon.max_benefit_capacity.value
          couponObj.unit = '元'
          couponObj.disabaled = true
          couponObj.tabImageStyle = getStyle({ backgroundImage:  productLineTag[item.product_id] })
          couponObj.product_line_tag_text = productLineTagText[item.product_id]
          couponObj.product_line_text = '已抢光'
          receiveCouponData.push(couponObj)
        }
      })
      const resArr = receiveCouponData.concat(...couponErr)
      console.log('resArr', resArr)
      return resArr
    },
  },
  methods: {
    click(e) { // ‘去使用’大按钮
      this.triggerEvent('click', e.detail)
    },
    // 单个券面点击
    couponClick(item) {
      if (item.disabaled) {
        return
      }
      this.triggerEvent('couponClick', {
          product_id: item.product_id,
          couponThisList: item.list,
          coupon_txt: productLineTextMap[item.product_id] || '',
          coupon_link: item.list?.[0]?.link,
        })
    },
    // 业务线跳转
    goToLink(item) {
      if (item.disabaled) {
        return
      }
      item.coupon_txt = productLineTextMap[item.product_id]
      this.triggerEvent('goToLink', { item })
    },
    // 分转成元，最多保留两位
    capAmountFixed(val) {
      return Math.round(val / 100 * 100) / 100
    },
  },
})
</script>

<style lang="stylus" scoped>
  .packet-open
    display flex
    justify-content center
    align-items center
    box-sizing border-box
    position relative
    background-size 100% 100%
    background-repeat no-repeat
    width 750rpx
    height 560rpx
    background-size: 100% 100%
    background-image: url('https://ut-static.udache.com/webx/ut/tQhjiQMSE4dlrzpBIRlLX.png')
    background-repeat: no-repeat
    position relative
    margin-top 227rpx
    .coupon-cover
      position absolute
      bottom 0
      width 700rpx
      height 250rpx
    .coupon
      width 224rpx
      height 334rpx
      background-image url('https://ut-static.udache.com/webx/ut/jNgH89VIvOP45_rNFU-P1.png')
      background-size 100% auto
      background-repeat no-repeat
      position relative
      display flex
      flex-direction column
      align-items center
      .cover
        position: absolute
        width 224rpx
        height 334rpx
        background-image url('https://ut-static.udache.com/webx/ut/oVyOC7VVBrr2O73q4x0Ly.png')
        background-size 100% auto
        background-repeat no-repeat
      .failed
        width: 127rpx
        height: 127rpx
        position absolute
        right: 0
        top: 95rpx
      .tag
        position absolute
        top 0
        width: 161rpx
        height: 43rpx
        line-height: 43rpx
        background-size: 100% auto;
        background-repeat: no-repeat;
        font-family: PingFangSC-Medium;
        font-size: 20rpx;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 500;
      .icon
        position absolute
        right: 20rpx
        top: 20rpx
        width: 20rpx;
        height: 20rpx;
      .award
        position absolute
        top 47rpx
        display flex
        align-items: baseline;
        .mark
          width 38rpx
          height 18rpx
          line-height 18rpx
          position absolute
          right -10rpx
          top 10rpx
          font-family: PingFangSC-Regular;
          font-size: 14rpx;
          color: #FEF1D6;
          text-align: center;
          font-weight: 400;
          border: 1rpx solid #FEEFD0;
          border-radius: 10rpx;
        .amount
          height: 80rpx;
          font-family: UniSansHeavyCAPS, UniSansHeavyCAPS-self;
          font-size: 80rpx;
          color: #FEEFD0;
          letter-spacing: -2rpx;
          text-align: center;
          font-weight: 900;
        .unit
          width: 32rpx;
          height: 30rpx;
          font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
          font-size: 29.4rpx;
          color: #FEEFD0;
          letter-spacing: 2.2rpx;
          text-align: center;
          font-weight: 900;
      .desc
        position absolute
        bottom 100rpx
        width: 156rpx;
        height: 50rpx;
        line-height: 50rpx
        border: 2rpx solid rgba(255,240,206,1);
        border-radius: 25rpx;
        font-family: PingFangSC-Medium;
        font-size: 24rpx;
        color: #FFF2D5;
        letter-spacing: 0;
        text-align: center;
        text-shadow: 0 1rpx 0 #BD2715;
        font-weight: 500;
        z-index 2
    .btn
      position absolute
      bottom 0
      background-image: url('https://ut-static.udache.com/webx/ut/D7ichazJcxtQ_YqlbvcFN.apng');
      background-size: 100% auto
      background-repeat: no-repeat
      bottom: 0
      width 540rpx
      height 160rpx
      line-height 120rpx
      font-size: 48rpx;
      font-family: PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      text-align center
      margin-bottom 0
      letter-spacing 1.71rpx
      background-color: transparent

</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {}
}
</script>
